var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-col self-start group_6 ml-55"},[_c('el-tabs',{staticClass:"tabs",model:{value:(_vm.selectType),callback:function ($$v) {_vm.selectType=$$v},expression:"selectType"}},_vm._l((_vm.typeData),function(item,index){return _c('el-tab-pane',{key:index,attrs:{"label":`${item.name}`,"name":item.id}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }